import {
    initialProfileDetailsState,
    initialProfileDetailState,
    initialProfileFeedPageState,
    initialProfileFeedPostsState,
    initialProfileFeedVirtualPageState,
    queryKey,
    ProfileDetailsState,
    ProfileDetailState,
    ProfileFeedPageState,
    ProfileFeedVirtualPageState,
} from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers';
import { BlogPostType } from 'mk2/apps/blogs/schemas';
import { AppState } from 'mk2/reducers';

export const getProfileDetailsState = (state: AppState): ProfileDetailsState => {
    return state.containers.blogs.profileDetails || initialProfileDetailsState;
};

export const getProfileDetailState = (state: AppState, username: string): ProfileDetailState => {
    return state.containers.blogs.profileDetails.profiles[username] || initialProfileDetailState;
};

export const getProfileDetailSearchState = (state: AppState, username: string, postType, query: string) => {
    const profileDetailState = getProfileDetailState(state, username);
    const key = queryKey(postType, query);
    return profileDetailState.searches[key] || initialProfileFeedPostsState;
};

export const getProfileFeedPageState = (state: AppState, username: string, postType: BlogPostType, query: string, page: number): ProfileFeedPageState => (
    getProfileDetailSearchState(state, username, postType, query).pages[page] || initialProfileFeedPageState
);
export const getProfileFeedVirtualPageState = (state: AppState, username: string, postType: BlogPostType, query: string, pageName: string): ProfileFeedVirtualPageState => (
    getProfileDetailSearchState(state, username, postType, query).virtualPages[pageName] || initialProfileFeedVirtualPageState
);
